
import { HttpError, isError } from "../../../state/helpers/Error"
import HttpClient from "../../../state/helpers/HttpClient"
import AccountStatement, { AccountStatementDto } from "../model/AccountStatement"

class AccountStatementService {

    static httpClient: HttpClient<AccountStatement, AccountStatementDto> =
        new HttpClient<AccountStatement, AccountStatementDto>(AccountStatement)

    static async get(accountStatementId: string): Promise<AccountStatement | HttpError> {
        const res = await this.httpClient.get(`/account-statements/${accountStatementId}`)
        if (isError(res)) {
            return res as HttpError
        }
        return res as AccountStatement
    }

    static async patch(accountStatementId: string, payload): Promise<AccountStatement | HttpError> {
        const res = await this.httpClient.patch(`/account-statements/${accountStatementId}`, payload)
        if (isError(res)) {
            return res as HttpError
        }
        return res as AccountStatement
    }

}

export default AccountStatementService




// WEBPACK FOOTER //
// ./src/customer/account-statement/service/AccountStatementService.tsx